<template>
    <div>
        <el-form :inline="true" size="small" :model="form">
            <el-form-item>
                <el-input
                    prefix-icon="el-icon-search" v-model.trim="form.keyword" clearable placeholder="设备ID"
                    @clear="getMsg(1)"
                    @keyup.enter.native="getMsg(1)" @blur="getMsg(1)"></el-input>
            </el-form-item>

            <el-form-item>
                <el-date-picker
                    v-model="form.time"
                    type="datetimerange"
                    clearable
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="timeChange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </el-form>

        <el-table
            ref="logTable"
            class="log_table"
            :data="logMsg.list"
            :height="tableHeight"
            :header-cell-style="{background:'#eef1f6',color:'rgba(0, 0, 0 ,.85)',fontSize:'14px', paddingLeft: '24px'}"
            :cell-style="{color:'rgba(0, 0, 0 ,.65)', padding: '16px 24px'}"
            v-loading="loading"
            style="width: 100%;">

            <el-table-column
                label="时间">
            </el-table-column>

            <el-table-column
                label="操作用户">
            </el-table-column>

            <el-table-column
                label="路由器名称">
            </el-table-column>

            <el-table-column
                label="路由器mac">
            </el-table-column>

            <el-table-column
                label="网络配置耗时（S）">
            </el-table-column>

            <el-table-column
                label="入云耗时（S）">
            </el-table-column>

        </el-table>

        <el-pagination
            background
            :current-page="page"
            @current-change="handleCurrentChange"
            :page-size="10"
            layout=" prev, pager, next"
            style="margin-top: 10px;text-align: right;"
            :total="parseInt(logMsg.totalRecords)">
        </el-pagination>

    </div>
</template>

<script>
export default {

    name: "networkConfigurationLog",

    data() {

        return {

            tableHeight: 300,

            logMsg: {
                list: [],
                totalRecords: 10
            },

            loading: false,

            page: 1,

            form: {
                //设备ID
                keyword: "",
                //时间区间
                time: "",
                //开始时间
                startTime: "",
                //结束时间
                endTime: "",
            }

        }

    },

    mounted() {
    },

    methods: {

        getMsg(page) {

        },

        timeChange(val) {
            this.form.startTime = val ? val[0] : '';
            this.form.endTime = val ? val[1] : '';
            this.getMsg(1);
        },

        setHeight() {
            this.tableHeight = window.innerHeight - 310;
        },

        handleCurrentChange(page) {
            this.page = page;
            this.getMsg(1);
        }

    }

}
</script>

<style scoped>
/deep/ .el-form--inline .el-form-item {
    margin-right: 16px!important;
}
</style>
